import type { COMMUNITY_TYPE } from '../../constants'

export type AccessSectionProps = {
  title: string
  description: string
  checked: boolean
  disabled: boolean
  value: COMMUNITY_TYPE
  page: PAGE_VIEW_ACCESS_SECTION
  handleClickRadioButton?: (value: COMMUNITY_TYPE) => void
}

export enum PAGE_VIEW_ACCESS_SECTION {
  CREATE_COMMUNITY_MODAL = 'create-community-modal',
  SIDEBAR = 'sidebar'
}
